import { axiosInstance } from "../axiosInstance";

export const getAllVans = async () => {
  const instance = await axiosInstance();
  return await instance.get("/van");
};
